<template>
    <div
        class="
            productOfShopMain
        "
        @click="goToProductDetail(shopId, productId)"
    >
        <img
            loading="lazy"
            class="productImg"
            :src="getImgUrl(productImg)"
        />
        <div class="verticalGully"></div>
        <div class="productTextDescriptionWrapper">
            <div
                class="
                    productName
                "
            >
                {{ productName }}
            </div>

            <span>销量 {{ productNumOfSold }}</span>
            
            <div style="display: flex; align-items: center;">
                <div class="priceWrapper">
                    <span class="priceNow"
                        >￥{{ returnFloatWith2DecimalFraction(productNowPrice) }}</span
                    >
                    <span
                        class="
                            priceOriginal
                        "
                        v-if="productOriginalPrice != 0"
                        >{{ returnFloatWith2DecimalFraction(productOriginalPrice) }}</span
                    >
                </div>
                <div ref="addToCartView" class="addToCartView" @click.stop="">
                    <van-badge v-if="specificationList.length > 1" :content="purchasedNumber" class="selectSpecificationButton">
                        <button
                            @click="showSpecification"
                            >选择规格</button>
                    </van-badge>
                    <ProductIncAndDesc v-model="purchasedNumber" :maxBuyNum="checkMaxBuyNum(shopId, productId, specificationList[0].id)" :maxNumber="specificationList[0].stock" @dataChange="updateCart" v-else />
                </div>
            </div>
        </div>

        <BaseParabolaAnimate ref="addToCartAnimate" :imgPic="getImgUrl(productImg)"/>
    </div>
</template>

<script>
//
import { mapState, mapGetters, } from 'vuex'

//
import ProductSpecification from '@/components/common/ProductSpecification.vue'

//
import { returnFloatWith2DecimalFraction } from '#/utils/number'


//
import ProductIncAndDesc from '@/components/shop/ProductIncAndDesc.vue'

export default {
    name: 'ProductOfShop',

    components: {
        ProductIncAndDesc,
    },

    props: {
        shopId: {
            type: Number,
            required: true,
        },

        productId: {
            type: Number,
            required: true,
        },

        productName: {
            type: String,
            required: true,
        },
        productNowPrice: {
            type: Number,
            required: true,
        },
        productOriginalPrice: {
            type: Number,
            required: true,
        },
        productNumOfSold: {
            type: Number,
            required: true,
        },
        productImg: {
            type: String,
            required: true,
        },

        specificationList: {
            type: Array,
            default: () => {
                return [
                    {
                        id: '',
                        pictures: '', //
                        productId: '',
                        specificationMsg: '',
                        specificationName: '', //
                        specificationPrice: '', //
                        stock: 0,
                    },
                ]
            },
        },

        shelfId: {
            default: () => {
                return [];
            },
        },
    },

    computed: {
        ...mapState({
            cartInfoAll: (state) => state.cart.cartInfoAll,
        }),

        ...mapGetters('cart', [
            'getCartInfo',
        ]),
    },

    data() {
        return {
            purchasedNumber: 0,
        }
    },

    created() {
        //
        this.checkPurchaseNumber()
    },

    watch: {
        cartInfoAll() {
            this.checkPurchaseNumber()
        },
    },

    methods: {
        returnFloatWith2DecimalFraction,

        checkPurchaseNumber() {
            //
            const cartInfo = this.getCartInfo(this.shopId);

            /**
             * 
             */
            this.purchasedNumber = 0;

            // console.log(
            //     `ProductOfShop, checkPurchaseNumber, this.productId: ${this.productId}`
            // )

            //
            for (let item of cartInfo.shoppingCars) {
                //
                if (item.productInfo.pId == this.productId) {
                    this.purchasedNumber += item.snum;
                }
            }
        },

        showSpecification() {
            this.createComponent(ProductSpecification, {
                props: {
                    specificationList: this.specificationList,
                    productName: this.productName,
                    productId: this.productId,
                    shopId: this.shopId,
                    productImg: this.productImg,
                    shelfId: this.shelfId,
                }
            })
        },

        updateCart(value)
        {
            //
            if(value > 0)
            {
                this.$refs.addToCartAnimate.addToCartAnimate(this.$refs.addToCartView, document.getElementById("componentCartIcon"));
            }

            //
            this.cartApiAddToCart(
                this.shopId,
                this.specificationList[0].id,
                value,
                this.productId,
                '',
            );
        },
    },
}
</script>

<style lang="scss" scoped>

.productOfShopMain
{
    width: 100%;
    display: flex;
    align-items: flex-start;
    box-sizing: border-box;
    padding: $padding;
    font-size: $fontSizeContent;
    line-height: 2em;
}

//
.productImg
{
    width: 6em; 
    height: 6em; 
    margin-right: $margin;
    border-radius: $borderRadius;
}

//
.productTextDescriptionWrapper
{
    flex-grow: 1;
    overflow: hidden;
}

.productName
{
    font-weight: 800;
    overflow-x: auto;
    width: 100%;
    white-space: nowrap;
}

.priceWrapper
{
    flex-grow: 1;
    white-space: nowrap;
    overflow-x: auto;
    margin-right: $margin;
}

.priceNow
{
    color: #ff4824;
}

.priceOriginal
{
    margin-left: $margin;
    text-decoration: line-through;
}

//
.addToCartView
{
    flex-shrink: 0;
    text-align:center;
    
}

.selectSpecificationButton
{
    margin-right: 0.5em;
}
</style>